import { Space } from "antd";
import type { ReactNode } from "react";
import type { SpaceProps } from "antd";

interface PageStackProps {
  children: ReactNode;
  size?: SpaceProps["size"];
}

export function PageStack({ children, size = "large" }: PageStackProps) {
  return (
    <Space direction="vertical" size={size} style={{ display: "flex" }}>
      {children}
    </Space>
  );
}
